module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"smsQueryTitle":"SMS Query","smsQueryText":"Query","smsSendTitle":"SMS Send","smsSendText":"Send"}}')
  delete Component.options._Ctor
}
